<!-- <app-ip-title-mobile
    [title]="'IP.CONSOLIDATED.GENERATED_TITLE'| translate" ></app-ip-title-mobile> -->
<app-ip-table
  [optionalTitle]="' '"
  [tableOption]="tableOptions"
  [propertyOrder]="propertyOrder"
  (action)="onAction($event)"
  [pageItems]="20"
  [filter]="false"
  service="consolidated"
  [paidOrders]="false"
  (chargeNewDate)="(changeStatus)"
  [scroll]="true"
  [searchField]="false"
  ></app-ip-table>
